import { observer } from 'mobx-react-lite'
import React, { FormEvent, useEffect } from 'react'
import __schedule from './__schedule'
import { Titles } from '../../../layouts/Titles'
import i from '../../../translations/i'
import {
    Button,
    Col,
    Divider,
    Input,
    Modal,
    Row,
    Segmented,
    Space,
    Switch,
    Upload,
    UploadProps
} from 'antd'
import { ExclamationCircleFilled, UploadOutlined } from '@ant-design/icons'
import projectController from '../project/project.controller'
import { config } from '../../../config/app'
import OptionTypesController from '../../../components/options/optionTypes.controller'
import OptionValuesController from '../../../components/options/optionValues.controller'
import { Options } from '../../../components/options/Options'

const { confirm } = Modal

export const Import = observer(() => {

    useEffect(() => {
        __schedule.get()
        projectController.get()
        OptionTypesController.get([], ['importDeleteMissingProductStatuses'])
          .then((keys: string[]) => OptionValuesController.get(keys))
    }, [])

    const showConfirmNow = () => {
        confirm({
            title: i.t('def:importCatalog'),
            icon: <ExclamationCircleFilled />,
            content: i.t('def:importNow'),
            centered: true,
            onOk() {
                __schedule.import_now()
            }
        })
    }

    const showConfirm = () => {
        confirm({
            title: i.t('def:importFromFile'),
            icon: <ExclamationCircleFilled />,
            content: i.t('def:importNowFile'),
            centered: true,
            onOk() {
                __schedule.upload()
            }
        })
    }

    const props: UploadProps = {
        fileList: __schedule.file ? [__schedule.file] : [],
        accept: __schedule.file_type === 'xml' ? '.xml,.yml' : '.xls,.xlsx',
        maxCount: 1,
        beforeUpload(info) {
            __schedule.file = info
            //showConfirm()
            return false
        }
    }

    const types = [
        { label: 'YClients', value: 'yclients', b2c: true },
        { label: 'Sbis', value: 'sbis', b2c: true },
        { label: 'XML / YML', value: 'file' },
    ]

    return(
        <>
            <form onSubmit={(e: FormEvent) => {
                __schedule.save(e)
                OptionValuesController.save(e)
            }}>
                <Titles
                    title={i.t('def:importSettings')}
                    buttons={[
                        { title: i.t('def:actions.back'), href: '/settings', type: 'dashed' },
                        { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
                    ]}
                    breadcrumb={[
                        { title: i.t('def:settings'), href: '/settings' },
                        { title: i.t('def:importSettings') },
                    ]}
                />

                <Row gutter={[20, 20]}>
                    <Col span={24}>
                        <label className="title">{i.t('def:importActionsItems')}:</label>
                    </Col>
                    <Col span={24}>
                        <label className="label">{i.t('def:importActionsItemsDescriptions')}</label>
                        <Segmented
                            value={projectController.project.import_action_elements}
                            options={[
                                { label: i.t('def:importActionsItemsDescriptionsOne'), value: 0 },
                                { label: i.t('def:importActionsItemsDescriptionsTwo'), value: 1 },
                                { label: i.t('def:actions.remove'), value: 2 },
                            ]}
                            onChange={(e) => projectController.set('import_action_elements', e, true)}
                        />
                    </Col>
                    {OptionTypesController.render && OptionValuesController.render &&
                        <Col span={24}>
                            <Options key="optionListImport" types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['importDeleteMissingProductStatuses']} />
                        </Col>
                    }
                    <Divider />
                    <Col span={24}>
                        <label className="title">{i.t('def:importingFromFile')}:</label>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <label className="label">{i.t('def:selectFileType')}</label>
                                <Segmented
                                    value={__schedule.file_type}
                                    options={[
                                        { label: 'XML / YML', value: 'xml' },
                                        // { label: 'Excel', value: 'excel' },
                                    ]}
                                    onChange={(e) => __schedule.file_type = String(e)}
                                />
                            </Col>
                            <Col span={24}>
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined />}>{i.t('def:selectFile')}</Button>
                                </Upload>
                            </Col>
                            <Col span={24}>
                                <Space>
                                    <Button onClick={showConfirm} type="primary" disabled={!__schedule.file}>{i.t('def:start')}</Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                    <Divider />
                    <Col span={24}>
                        <label className="title">{i.t('def:importSchedule')}</label>
                    </Col>
                    <Col span={24} className="switch-block">
                        <div className="element">
                            <div></div>
                            <Switch
                                checked={__schedule.schedule.schedule_enabled}
                                onChange={e => __schedule.schedule.schedule_enabled = e}
                                size="small"
                            />
                            <div>
                                <span>{__schedule.schedule.schedule_enabled ? i.t('def:included') : i.t('def:switchedOff')}</span>
                            </div>
                        </div>
                    </Col>
                    {__schedule.schedule.schedule_enabled ?
                        <>
                            <ImportFile />

                            <Divider />
                            <Col span={24}>
                                <Space>
                                    <Button
                                        type='dashed'
                                        href="/settings/import/schedule"
                                    >
                                        {i.t('def:scheduleSettings')}
                                    </Button>
                                    <Button
                                        onClick={showConfirmNow}
                                        type='dashed'
                                        danger
                                    >
                                        {i.t('def:startImportNow')}
                                    </Button>
                                </Space>
                            </Col>
                        </> : <></>
                    }
                </Row>
            </form>
        </>
    )
})

const ImportFile = observer(() => {

    return(
        <>
            <Divider />
            <Col span={24}>
                <label className="label">{i.t('settings:label.link')}</label>
                <Input
                    value={__schedule.schedule.type_file_uri}
                    onChange={(e) => __schedule.schedule.type_file_uri = e.target.value}
                    placeholder={i.t('settings:label.link')}
                />
            </Col>
        </>
    )
})